<template>
  <div class="traceability-map">
    <div class="container-map">
      <div class="wrapper-map-header">
        <svg-loader
          icon="icon-traceability-map"
          src="/static/images/icon-traceability-in-transit.svg"
          class="icon"
        />
        <p class="map-title">
          {{ title }}
        </p>
      </div>
      <GmapMap
        ref="mapRef"
        :center="locationsAvailable[0].position"
        :zoom="5"
        map-type-id="roadmap"
        style="width: 100%; height: 25vw"
      >
        <GmapMarker
          v-for="(location, index) in locationsAvailable"
          :key="index"
          :icon="location.icon"
          :position="location.position"
          :clickable="false"
          :draggable="false"
          :optimized="false"
        />
      </GmapMap>

      <div class="legend">
        <md-icon md-src="/static/images/icon-lab.png" />
        <p>Seu Laboratório</p>
        <md-icon md-src="/static/images/icon-transport.png" />
        <p>Amostras em trânsito</p>
        <md-icon md-src="/static/images/icon-alvaro.png" />
        <p>NTO Alvaro</p>
      </div>
    </div>

    <div class="tracking-details">
      <div class="traceability-header">
        <svg-loader
          icon="icon-tracking-details"
          src="/static/images/icons/map.svg"
          class="icon"
        />
        <h2>Trajeto</h2>
      </div>

      <div class="wrapper-tracking-details">
        <div class="location-timeline">
          <div class="timeline-item">
            <span
              class="dot"
              :class="{ 'status-done': checkLaboratorio }"
              aria-hidden="true"
            />
            <div class="item-content">
              <strong>{{ laboratory.name }}</strong>
              <p class="address">
                {{ laboratory.address }}
              </p>
            </div>
          </div>

          <div class="timeline-item">
            <span
              class="dot"
              :class="{ 'status-done': checkAtual }"
              aria-hidden="true"
            />
            <div class="item-content">
              <strong>Localização Atual</strong>

              <div
                v-if="lastUpdateText"
                class="updated-time"
              >
                Atualizado <span>{{ lastUpdateText }}</span>
              </div>
            </div>
          </div>

          <div class="timeline-item">
            <span
              class="dot"
              :class="{ 'status-done': checkEntregueNto }"
              aria-hidden="true"
            />
            <div class="item-content">
              <strong>{{ nto.name }}</strong>
              <p class="address">
                {{ nto.address }}
              </p>
            </div>
          </div>
        </div>

        <button
          v-if="buttonLabel"
          class="btn btn-primary"
          @click="buttonAction"
        >
          {{ buttonLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'

const BOUNDS_BACKUP = {
  na: {
    j: -26.934151450576124,
    l: -7.95486694,
  },
  ga: {
    j: -55.69347395312502,
    l: -34.85096213999998,
  },
}

export default {
  name: 'TraceabilityMaps',
  components: {
    Spinner,
  },
  props: {
    laboratory: {
      type: Object,
      default: () => ({}),
    },
    nto: {
      type: Object,
      default: () => ({}),
    },
    currentLocation: {
      type: Object,
      default: () => ({}),
    },
    oSAlvaro: {
      type: String,
      required: true,
    },
    currentStatus: {
      type: String,
      required: true,
    },
    locations: {
      type: Array,
      default: () => [],
    },
    buttonAction: {
      type: Function,
      default: () => {},
    },
    buttonLabel: {
      type: String,
      default: null,
    },
    lastUpdateText: {
      type: String,
      default: 0,
    },
  },
  computed: {
    title() {
      return `OS ${this.oSAlvaro}`
    },
    locationsAvailable() {
      return this.locations.filter(location => location.position.lat !== 0)
    },
    checkLaboratorio(){
      return true;
    },
    checkAtual(){
      if(this.currentStatus == 'AGUARDANDO_RETIRADA' || this.currentStatus == 'AMOSTRA_OBTIDA' || this.currentStatus == 'CADASTRADO')
        return false;

      return true;
    },
    checkEntregueNto(){
      if(this.currentStatus == 'AGUARDANDO_RETIRADA' || this.currentStatus == 'AMOSTRA_OBTIDA' || this.currentStatus == 'CADASTRADO' || this.currentStatus == 'EM_TRANSITO')
        return false;

      return true;
    },
  },
  methods: {
    centralizeMap() {
      this.$refs.mapRef.$mapPromise.then(map => {
        const bounds = map.getBounds()

        if (bounds) {
          for (let l of this.locationsAvailable) {
            bounds.extend(l.position)
          }
          map.fitBounds(bounds)
        } else {
          map.fitBounds(BOUNDS_BACKUP)
        }
      })
    },
    updateMapCenter() {
      setTimeout(() => {
        this.centralizeMap()
      }, 500)
    },
    clearAllLocations() {
      this.locations.map(elem => {
        elem.position.lat = 0
        elem.position.lng = 0
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.traceability-map {
  margin-top: 1em;
  font-family: 'Exo 2', sans-serif !important;
  display: flex;
  gap: 1rem;

  .btn {
    width: 100%;
    margin-top: 1.5rem;
    font-family: 'Exo 2', sans-serif;
    font-size: 14px;
    font-weight: 600;
    max-width: 250px;
  }

  @media (max-width: 1003px) {
    flex-direction: column;
    max-width: 100% !important;
  }

  .updated-time {
    color: #999999;
    font-size: 12px;

    span {
      font-weight: 600;
    }
  }

  .map-title {
    color: #7f1a54;
    margin-bottom: 0.5rem;
  }

  .wrapper-map-header {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    max-width: fit-content;
  }

  .current-location {
    .address {
      margin: 0.7rem 0;
      color: #595959;
    }

    h2 {
      color: #ec2072;
      font-size: 18px;
    }
  }

  .container-map {
    width: calc(100% - 350px);
  }

  .tracking-details {
    width: 100%;
    max-width: 350px;
  }

  .traceability-header {
    display: flex;
    width: 110px;

    .icon {
      margin-right: 8px;
    }

    h2 {
      color: #7f1a54;
      font-size: 23px;
    }
  }

  .location-timeline {
    font-family: 'Exo 2', sans-serif;
    font-size: 14px;
    line-height: 1.35;
    max-width: 360px;
    color: #111;
    padding: 1rem;
  }

  .timeline-item {
    position: relative;
    display: flex;
    gap: 12px;
    padding-bottom: 16px;
  }

  .timeline-item:last-child {
    padding-bottom: 0;
  }

  .dot {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-top: 4px;
    background: #cfcfcf;
    flex: 0 0 10px;
  }

  .dot::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 12px;
    transform: translateX(-50%);
    width: 1px;
    height: calc(100% + 4rem);
    border-left: 1px dashed #cfcfcf;
  }

  .timeline-item:last-child .dot::after {
    display: none;
  }

  .status-done {
    background: #33c27a;
  }

  .status-pending {
    background: #cfcfcf;
  }

  .item-content p {
    margin: 0;
    color: #666;
  }

  .item-content {
    flex: 1;

    .address {
      color: #595959;
    }
  }

  .item-content strong {
    display: block;
    font-weight: 700;
    margin-bottom: 2px;
  }

  .loading {
    margin: 8em;
  }

  .legend {
    display: flex;
    align-items: flex-start;
    padding-right: 35px;
    margin: 20px 0px 0px;

    img {
      margin-right: 10px;
    }

    p {
      margin: auto;
      margin-left: 0px;
      font-family: 'Exo 2', sans-serif !important;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 26px;
      color: #7a7a7a;

      & + img {
        margin-left: 10px;
      }
    }
  }

  .vue-map-container .vue-map {
    position: absolute !important;
  }

  .standard-modal__title {
    font-family: 'Exo 2', sans-serif !important;
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 26px;
    color: #7f1a54;

    .md-icon {
      margin: 0 !important;
    }
  }

  .not-found {
    height: 300px;

    .container {
      top: 35%;
      width: 90%;
      position: relative;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: auto;

      .md-icon {
        width: 50px;
        height: 50px;
        margin-right: 15px;
        display: block;
      }

      p {
        font-family: 'Exo 2', sans-serif !important;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        text-align: center;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #7a7a7a;
      }
    }
  }
}
</style>
